import { getDataTableByCanonicalType } from '../features/visual-analytics/charts/chartDataBindings';
import { TpAnalyticsData, TpCanonicalTypeInfo, TpDataContext } from './interfaces';
import { showErrorMessage } from '../components/message-boxes/ErrorMessage';

// For size & efficiency reasos, the actual data context datatables are not stored in the redux store, but in a separate entitity
// TpDataContextRef in the store is used to keep track of changes, by incrementing statusIndex

export const analyticsDataStorage: TpAnalyticsData = {
  dataContexts: {},
  postFetchCallBacks: {},
};

export function updateCanonicalTypeRestrictionData(canonicalTypeInfo: TpCanonicalTypeInfo) {
  const itemIdList = canonicalTypeInfo.itemIdList;
  let restrictionList: number[] | null = null;
  const restrictedItemId2Inxdex: { [itemId: string]: number } = {};

  if (!itemIdList) {
    showErrorMessage('ItemIdList is undefined or empty');
    return;
  }

  if (canonicalTypeInfo.restrictedItemsMap) {
    restrictionList = [];
    for (let idx = 0; idx < itemIdList.length; idx++)
      if (canonicalTypeInfo.restrictedItemsMap[itemIdList[idx]]) {
        restrictedItemId2Inxdex[itemIdList[idx]] = restrictionList.length;
        restrictionList.push(idx);
      }
  } else {
    for (let idx = 0; idx < itemIdList.length; idx++) restrictedItemId2Inxdex[itemIdList[idx]] = idx;
  }
  canonicalTypeInfo.restrictionList = restrictionList;
  canonicalTypeInfo.restrictedItemId2Inxdex = restrictedItemId2Inxdex;
}

export function updateDataContextAll(dataContext: TpDataContext) {
  for (const canonicalTypeId in dataContext.canonicalTypes) {
    const canonicalTypeInfo = dataContext.canonicalTypes[canonicalTypeId];

    // first, we must populate the list with item IDs
    const dataTable = getDataTableByCanonicalType(dataContext, canonicalTypeId);
    canonicalTypeInfo.itemIdList = dataTable.columnData[dataTable.colItemId];

    updateCanonicalTypeRestrictionData(canonicalTypeInfo);
  }
}

export function perfTestStart() {
  return {
    timeStamp: performance.now(),
  };
}

export function perfTestStop(perfObj: any, descr: string) {
  console.log(`${(performance.now() - perfObj.timeStamp).toFixed(2)} ms for ${descr}`);
}

function performanceTests() {
  const count = 50000000;

  const tst = new Float32Array(5);
  tst[0] = 1;
  tst[1] = 2;
  tst[3] = NaN;
  tst[4] = 3;

  console.log(`${tst} ${isNaN(tst[0])}, ${isNaN(tst[3])}}`);

  console.log(`Starting performance tests - ${count / 1e6}M data points`);

  function fnc(vl: number) {
    return !isNaN(vl);
  }

  let pf;
  let arr: any;
  let dict: any;
  let sm: number;

  pf = perfTestStart();
  sm = 0;
  for (let i = 0; i < count; i++) if (fnc(i)) sm += i;
  perfTestStop(pf, 'Evaluating large number of function calls');

  pf = perfTestStart();
  arr = [];
  const ch = ['afvrergrha', 'ebdddhe', 'ofnffho', 'udbdbddhu', 'obdfdbdbdfbdi'];
  for (let i = 0; i < count; i++) arr.push(ch[i % 5]);
  perfTestStop(pf, 'Creating large string array');

  pf = perfTestStart();
  arr = [];
  for (let i = 0; i < count; i++) arr.push(i);
  //arr.push('b;la');
  perfTestStop(pf, 'Creating large array');

  pf = perfTestStart();
  sm = 0;
  for (let i = 0; i < count; i++) sm += arr[i];
  perfTestStop(pf, 'Evaluating large array');

  pf = perfTestStart();
  arr = new Int32Array(count);
  for (let i = 0; i < count; i++) arr[i] = i;
  perfTestStop(pf, 'Creating large floatarray');

  pf = perfTestStart();
  sm = 0;
  for (let i = 0; i < count; i++) sm += arr[i];
  perfTestStop(pf, 'Evaluating large floatarray');

  pf = perfTestStart();
  // eslint-disable-next-line prefer-const
  dict = {};
  for (let i = 0; i < count; i++) dict[i] = i;
  perfTestStop(pf, 'Creating large dict');

  pf = perfTestStart();
  sm = 0;
  for (let i = 0; i < count; i++) sm += dict[i];
  perfTestStop(pf, 'Evaluating large dict');
}
